import { render } from "./InternalRepairForm.vue?vue&type=template&id=eed1ed58"
import script from "./InternalRepairForm.vue?vue&type=script&lang=js"
export * from "./InternalRepairForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__